import { ArrowRight, Edit, Trash2 } from "react-feather"
import { cn } from "@/lib/utils"

interface SupportHistoryItemProps {
  index: number
  type: string
  datetime: string
  fromPerson: string
  toPerson: string
  content: string
  fromCategory?: string
  toCategory?: string
  onEdit?: () => void
  onDelete?: () => void
}

// FROM → TO の方向を区別し、未設定・未知の区分は「それ以外」として扱う。
function getHeaderBgColor(fromCategory?: string, toCategory?: string): string {
  const normalizeCategory = (category?: string) =>
    category && ["contractor", "emergency", "owner", "oc"].includes(category) ? category : "other"
  const from = normalizeCategory(fromCategory)
  const to = normalizeCategory(toCategory)

  if (
    (from === "contractor" && (to === "emergency" || to === "oc")) ||
    ((from === "emergency" || from === "oc") && to === "contractor")
  ) {
    return "bg-[#DDF6FF]"
  }
  if (
    (from === "owner" && (to === "emergency" || to === "oc")) ||
    ((from === "emergency" || from === "oc") && to === "owner")
  ) {
    return "bg-[#F9F7DB]"
  }
  if (
    (from === "emergency" && (to === "oc" || to === "other")) ||
    (from === "other" && to === "emergency")
  ) {
    return "bg-slate-100"
  }
  return "bg-[#FFE3CD]"
}

export function SupportHistoryItem({
  index,
  type,
  datetime,
  fromPerson,
  toPerson,
  content,
  fromCategory,
  toCategory,
  onEdit,
  onDelete,
}: SupportHistoryItemProps) {
  return (
    <div className="flex border">
      <div className="flex-shrink-0 w-6 text-center flex items-center justify-center border-r">
        <span className="text-sm font-medium">{index}</span>
      </div>
      <div className="flex-1">
        <div className={cn("p-2.5", getHeaderBgColor(fromCategory, toCategory))}>
          <div className="flex items-center justify-between text-xs mb-1 text-slate-500 font-semibold">
            <span>{type}</span>
            <div className="flex items-center gap-2">
              <span>{datetime}</span>
              {onEdit && (
                <button
                  type="button"
                  onClick={onEdit}
                  className="p-1 hover:bg-slate-200 rounded transition-colors"
                  aria-label="編集"
                >
                  <Edit size={14} className="text-slate-600" />
                </button>
              )}
              {onDelete && (
                <button
                  type="button"
                  onClick={onDelete}
                  className="rounded p-1 transition-colors hover:bg-red-100"
                  aria-label="削除"
                >
                  <Trash2 size={14} className="text-red-500" />
                </button>
              )}
            </div>
          </div>
          <div className="flex items-center gap-2 text-sm">
            <span>{fromPerson}</span>
            <ArrowRight className="w-3 h-3" />
            <span>{toPerson}</span>
          </div>
        </div>
        <p className="text-sm p-2.5 whitespace-pre-wrap">{content}</p>
      </div>
    </div>
  )
}
